import { If, TabLink } from "components";
import { t } from "i18next";
import { ContentLayout } from "layouts";
import { Routes } from "modules/common";
import {
  AffinityGraphEditor,
  EnrichmentCoverage,
  EnrichmentProfiles,
  SuggestionDiscountSettings
} from "modules/recommendation";
import { useParams } from "react-router-dom";

import styles from "./RecommendationsPage.module.scss";

const RecommendationsPage = () => {
  const { activeTab } = useParams();
  const recommendationRoutes = Routes.find((route) => {
    return route.label === "Recommendations";
  })?.nestedRoutes;

  return (
    <ContentLayout title={t("Recommendations")}>
      <div className={styles.page}>
        <If condition={!!recommendationRoutes}>
          <nav className={styles.page__tabs}>
            {recommendationRoutes?.map((route) => (
              <TabLink
                key={route.label}
                pathName={route.path}
                label={t(route.label)}
              />
            ))}
          </nav>
        </If>

        <If condition={activeTab === "affinity"}>
          <AffinityGraphEditor />
        </If>

        <If condition={activeTab === "enrichment"}>
          <EnrichmentCoverage />
        </If>

        <If condition={activeTab === "profiles"}>
          <EnrichmentProfiles />
        </If>

        <If condition={activeTab === "discount"}>
          <SuggestionDiscountSettings />
        </If>
      </div>
    </ContentLayout>
  );
};

export default RecommendationsPage;
